import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./App.css";
import reportWebVitals from "./reportWebVitals";

/**
 * scripts/prerender.js writes a static <title>, meta, canonical and JSON-LD
 * into every built HTML file so crawlers that do not run JavaScript still get
 * a complete document. Once react-helmet-async has written the live versions,
 * those static tags are duplicates — and a page with two canonicals or two
 * descriptions lets Google pick whichever it likes. Retire them here.
 */
function removePrerenderedHeadTags() {
  document
    .querySelectorAll("head [data-prerender]")
    .forEach((el) => el.remove());
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Helmet writes its tags in a mount effect, so wait a frame before clearing
// the static ones — the document is never left without a title or canonical.
requestAnimationFrame(() => requestAnimationFrame(removePrerenderedHeadTags));

reportWebVitals();
